import { InjectionToken } from '@angular/core';
import { IAppSettingsService } from './app-settings-service.interface';

export const APP_SETTINGS_SERVICE = new InjectionToken<IAppSettingsService>(
  'APP_SETTINGS_SERVICE'
);
